import React, { Component } from 'react'
import { Route, Link } from 'react-router-dom'
import Home from './views/Home'
import MyWife from './views/MyWife'
import WifeDetail from './views/WifeDetail'
import BuyCoin from './views/BuyCoin'
import About from './views/About'
import { Navbar, NavItem, Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import getWeb3 from './utils/getWeb3'
import SimpleStorageContract from '../build/contracts/LPCoin.json'

const contract = require('truffle-contract')
const simpleStorage = contract(SimpleStorageContract)

class App extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      web3: null,
      network: ""
    };
  }
  
  componentDidMount() {
    getWeb3.then(results => {
      this.setState({ web3: results.web3 })
      this.getNetwork()
    }).catch((e) => {
      console.log(e)
    })
  }

  getNetwork() {
    // this.state.web3.eth.filter('latest').watch(this.syncEthInfo);
    this.state.web3.eth.net.getId().then(netId => {
      var network = "Unknown Network";
      switch (netId) {
        case 1:
        network = "Main Ethereum Network"
        break
        case 2:
        network = "Morden Test Network"
        break
        case 3:
        network = "Ropsten Test Network"
        break
        case 4:
        network = "Rinkeby Test Network"
        break;
        case 42:
        network = "Kovan Test Network"
        break;
        default:
        network = "Unknown Network"
      }
      this.setState({ network: network });
    })
  }

  // syncEthInfo = () => {
  //   this.state.web3.version.getNetwork((e, network) => this.setState({ network }));
  // };

  render() {
    return (
      <div className="App">

      <Navbar>
        <Navbar.Header>
          <Navbar.Brand>
            2018年1月番
          </Navbar.Brand>
        </Navbar.Header>
        <Nav>
          <LinkContainer to="/all">
            <NavItem>所有角色</NavItem>
          </LinkContainer>
          <LinkContainer to="/mywife/self">
            <NavItem>我投币的角色</NavItem>
          </LinkContainer>
          <LinkContainer to="/buycoin">
            <NavItem>购买老婆币</NavItem>
          </LinkContainer>
          <LinkContainer to="/about">
            <NavItem>关于&说明</NavItem>
          </LinkContainer>
        </Nav>
        <Nav pullRight>
          <NavItem>
            { this.state.network }
          </NavItem>
        </Nav>
      </Navbar>



      
        <Route exact path="/" component={Home}/>
        <Route exact path="/all" component={Home}/>
        <Route path="/mywife/:address" component={MyWife}/>
        <Route path="/wifedetail/:id" component={WifeDetail}/>
        <Route path="/buycoin" component={BuyCoin}/>
        <Route path="/about" component={About}/>


      </div>
    );
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js